import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { FeedService } from './feed.service';
import { Observable, Subject } from 'rxjs';


@Injectable()
export class RouterResolverService implements Resolve<any> {

  postCollections

  constructor(private http: FeedService) { }

  UserData = new Subject();

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> |
          Promise<any> | any {
  
            //return this.http.getPost();
           
          }
}
